import { Box } from '@mui/material';
import { VegaBundle } from 'services/store/ai/types';
import { useSubscription } from 'services/hooks';
import DurationUpgradeBanner from '../../DurationUpgradeBanner/DurationUpgradeBanner';
import Track from '../../Track/Track';
import { TrackError, TrackLoader } from '../../Track/components';
import { TrackContainer } from './styled';

interface BundleSongsProps {
  bundle: VegaBundle;
  isLoading?: boolean;
}

const BundleSongs = ({
  bundle: { songs, isPreview, isFinished },
  isLoading,
}: BundleSongsProps) => {
  const { isFreeAccount } = useSubscription();
  return (
    <>
      {isPreview && isFreeAccount && <DurationUpgradeBanner />}
      <Box>
        {isFinished && !songs.length ? (
          <TrackError />
        ) : (
          songs.map((song, index) => (
            <TrackContainer
              // eslint-disable-next-line react/no-array-index-key
              key={index}
            >
              {isLoading ? <TrackLoader /> : <Track data={song} />}
            </TrackContainer>
          ))
        )}
      </Box>
    </>
  );
};

export default BundleSongs;
